var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header-area"},[_c('div',{staticClass:"container"},[_c('figure',{staticClass:"logo",on:{"click":_vm.gotoHome}},[_c('img',{attrs:{"src":"/assets/img/app/logo-desktop.png","alt":"Bonauf"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }